import jQuery from 'jquery';
import Swal from 'sweetalert2';
import "@fortawesome/fontawesome-free";
import 'bootstrap';
import 'lazysizes';

window.$ = window.jQuery = jQuery;
window.Swal = Swal;

import initCarousel from './modules/initCarousel';
import openBag from './modules/openBag';
import openBagDownload from './modules/openBagDownload';
import openSearch from './modules/openSearch';
import addDownloadCart from './modules/addDownloadCart';
//import initAOS from './modules/initAOS';
import menuMobileLp from './modules/menuMobileLp';
// import menuPages from './modules/menuPages'
import submenu from './modules/submenu';
import initModal from './modules/modal.js';
import alertPhoto from './modules/alertPhoto.js';
import filterSearch from './modules/filterSearch.js';
import multipleSelectNewsletter from './modules/multipleSelectNewsletter.js';
import myMask from './modules/myMask.js';
import fillCities from './modules/fillCities.js';
import validateForm from './modules/validateForm.js';
import popupBoleto from './modules/popupBoleto.js';
import popupAvisoBoleto from './modules/popupAvisoBoleto.js';
import popupCorona from './modules/popupCorona.js';
import popupLGPD from './modules/popupLGPD.js';
import popupAlertText from './modules/popupAlertText.js';
import popupFerias from './modules/popupFerias.js';
import headerHover from './modules/headerHover';
import popups from './modules/popups.js';

import changeColorMenu from './modules/changeColorMenu';
import validateStage from './modules/sacValidateStage';

import customer from './pages/customerService';

headerHover();
initModal();
initCarousel();
openBag();
openBagDownload();
openSearch();
addDownloadCart();
//initAOS();
// menuMobileLp();

submenu();
alertPhoto();
popupBoleto();
popupAvisoBoleto();
popupCorona();
popupLGPD();
popupAlertText();
popupFerias();
popups();
filterSearch();
multipleSelectNewsletter();
myMask();
fillCities();
validateForm();

changeColorMenu();
validateStage();

customer();
if (typeof onTouchStart !== 'undefined') {
    document.addEventListener('touchstart', onTouchStart, {passive: true});
}
// menuPages()
